import styled from "styled-components";

export const Container = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 0.4rem;

	p {
		margin: 0;
	}

	& > p:nth-child(even) {
		text-align: right;
	}
`;

export const TotalPrice = styled.p`
	font-size: 1.2rem;
	font-weight: bold;
`;
